import React, { CSSProperties } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Bucket } from "../../../../../api/indicators";
import EmptyResultDashboard from "../EmptyResultDashboard";
import { selectStyle } from "./AreaChart";


interface AreaChartErrorProps {
    title: string;
    description: string;
    bucket: Bucket;
    setBucket: (bucket: Bucket) => void;
}

const AreaChartError = ({ title, description, bucket, setBucket }: AreaChartErrorProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ marginRight: '4px', width: '100%', display: 'flex', flexDirection: 'column', height: 'auto' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', width: 'auto', margin: '6px' }}>
                <Typography variant="h2">{title}</Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: '400', marginTop: '10px' }}>{description}</Typography>
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <TextField
                        size="medium"
                        sx={selectStyle}
                        select
                        label={t("screens.dashboarding.charts.showBy")}
                        value={bucket}
                        id="period"
                        onChange={(event) => setBucket(event.target.value as Bucket)}
                        inputProps={{ 'data-qa-id': "filterPeriodOption" }}
                    >
                        <MenuItem value="day">{t('components.select.days')}</MenuItem>
                        <MenuItem value="week">{t('components.select.week')}</MenuItem>
                        <MenuItem value="hour">{t('components.select.hour')}</MenuItem>
                    </TextField>
                </Box>
            </Box>
            <Box>
                <EmptyResultDashboard
                    title={t("screens.dashboarding.dataUnavailable")}
                    subtitle={t("screens.dashboarding.dataUnavailableText")}
                />
            </Box>
        </Box>
    )
}

export default AreaChartError;
